<template>
    <!--<div ref="mapContainer" class="map-container"></div>-->
</template>

<script>
/*import axios from 'axios';
import mapboxgl from 'mapbox-gl';
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions';
import { mdiGasStation } from '@mdi/js';*/
//mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;

export default {
    name: 'Map',
    /*mounted() {
        const map = new mapboxgl.Map({
            container: this.$refs.mapContainer,
            style: 'mapbox://styles/hcobian/clxtd8p9203v701qo756u664q'
        });
        const directions = new MapboxDirections({
            accessToken: mapboxgl.accessToken,
            unit: 'metric',
            profile: 'mapbox/driving',
            controls: {
                instructions: true,
                profileSwitcher: false
            }
        });

        this.getStations();

        //map.addControl(directions, 'top-left');

        /*map.on('style.load', () => {
            map.setConfigProperty('basemap', 'lightPreset', 'dusk');
        });*/

        /*const updateLocation = () =>
            this.$emit('update:modelValue', this.getLocation());

        map.on('move', updateLocation);
        map.on('zoom', updateLocation);
        map.on('rotate', updateLocation);
        map.on('pitch', updateLocation);

        this.map = map;
    },*/
    unmounted() {
        //this.map.remove();
        //this.map = null;
    },
    data: () => ({
        stations: [],
        el: null
    }),
    methods: {
        /*getStations() {
            axios
                .get('v2/locations/stations/geodata')
                .then(response => {
                    this.stations = response.data;
                    this.addMarkersToMap();
                })
                .catch(error => {
                    console.error(error);
                });
        },
        addMarkersToMap() {
            this.stations.forEach(station => {
                if (station.geo_data) {
                    const location = station.geo_data.location.coordinates;
                    const el = this.createMarkerElement(station);

                    new mapboxgl.Marker({
                        color: '#1976d2',
                        el
                    })
                        .setLngLat([location[0], location[1]])
                        .setPopup(
                            new mapboxgl.Popup().setHTML(
                                `
                                <h3>${station.Name}</h3><br>
                                <table>
                                    <tr>
                                        <td>Address:</td>
                                        <td>${station.Address}</td>
                                    </tr>
                                    <tr>
                                        <td>City:</td>
                                        <td>${station.City}</td>
                                    </tr>
                                    <tr>
                                        <td>State:</td>
                                        <td>${station.State}</td>
                                    </tr>
                                    <tr>
                                        <td>Zip:</td>
                                        <td>${station.Zip}</td>
                                    </tr>
                                    <tr>
                                        <td>Phone:</td>
                                        <td>${station.Phone}</td>
                                    </tr>
                                </table>
                                <a href="https://www.google.com/maps/search/?api=1&query=${
                                    location[1]
                                },${
                                    location[0]
                                }" target="_blank">Open in Google Maps</a>
                                <h4>Tanks</h4>
                                <table>
                                    <tr>
                                        <th>Product</th>
                                        <th>Capacity</th>
                                        <th>Level</th>
                                        <th>Estimated Runout</th>
                                    </tr>
                                    ${station.tanks.map(tank => {
                                        return `
                                        <tr>
                                            <td>${tank.Tank}</td>
                                            <td>${tank.product.Product}</td>
                                            <td>${tank.Capacity}</td>
                                            <td>${tank.runout_at}</td>
                                        </tr>
                                        `;
                                    })}
                                </table>
                                </div>
                                `
                            )
                        )
                        .addTo(this.map);
                }
            });
        },
        createMarkerElement(location) {
            const el = document.createElement('div');
            el.className = 'marker';
            el.innerHTML = `
        <svg class="marker" style="width:24px;height:24px;color:blue" viewBox="0 0 24 24">
          <path d="${mdiGasStation}" />
        </svg>
      `;
            el.addEventListener('click', this.getLocationClick(location));
            return el;
        },
        getLocationClick(data) {
            console.info(data);
        }*/
    }
};
</script>

<style scoped>
.map-container {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
}

.marker {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    color: #1976d2; /* Adjust the color as needed */
}

.marker svg {
    color: #1976d2; /* Adjust the color as needed */
}
</style>
